<!--  -->
<template>
  <!--  -->
  <div class="prview_box">

    <div :class="[type == 1 ? 'tybox' : '']">
      <div v-if="typestring == 'index'&&contenttitle!==''" style="text-align: center;background-color: rgb(249, 251, 180);margin: 10px;border-radius: 5px;padding: 5px;">{{ contenttitle }}</div>
      <div :class="type === 1 ? 'phoner_boxone' : 'phoner_box'">
        <div class="all_boxr">
          <div class="content_box" v-html="content" />
          <div v-for="item,index in attachments" :key="index" class="at_box">
            <!-- <div class="onebox">
              <img v-if="item.thumburl" :src="itemthumburl" style="width:80px;height:80px;margin:10px 0px 0px 23px">
            </div> -->
            <!-- <div class="onebox">
              <div class="within_box">
                <div class="title_boxr">{{ item.name }}</div>
                <div class="imaetext se_top">
                  <div class="describe_text">{{ item.textPagepath }}</div>
                  <div>
                    <img style="width:50px;height:50px;object-fit: contain;" :src="item.thumburl">
                  </div>
                </div>
              </div>
            </div> -->

            <div class="onebox">
              <div>
                <div class="mincard">
                  <!-- <div style="display: flex;align-items: center;"><img :src="item.sp_miniprogram.weappiconurl" style="width: 25px;" alt="" srcset=""><div class="mincard_title" style="margin-bottom: 0px;margin-left:5px">{{ item.sp_miniprogram.des_1 }}</div></div> -->
                  <div class="mincard_enjoy">{{ item.name }}</div>
                  <div>
                    <img :src="item.thumburl" class="imgrbox">
                  </div>
                  <div class="line" />
                  <div class="bottomwr">
                    <!-- <img src="https://cdn.mdxcx.net/default/20210625/33695da2774d54929387886410828920.png%21watermark" alt="" style="width:28px;height:28px"> -->
                    <div class="weadar">{{ item.remark }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
// import { spWorkWechatOpStrategyDetail } from '@/api/OperationStrategy.js'
import { mptypeslist } from '@/api/sourceMaterial.js'
// import { sprEnterprise } from '@/api/officialaccount.js'
export default {
  data() {
    return {
      attachments: [],
      programtype: [],
      content: '',
      type: null,
      dialogVisible: false,
      customdialogVisible: false,
      employee_no: null,
      external_user_id: null,
      employee_name: '',
      external_name: '',
      adlist: [],
      detailList: [],
      contenttitle: '',
      typestring: '',
      currentIndex: 0,
      show: 8,
      isshow: 0,
      isFunctionExecuting: false

    }
  },
  created() {

  },
  async mounted() {

  },
  methods: {

    async send(item, type, show) {
      console.log('item:', item)
      this.show = show
      this.type = type
      // eslint-disable-next-line eqeqeq
      if (item == {}) {
        return
      }
      this.attachments = [item]
      this.getmptypeslist()
    },
    // 获取小程序消息类型
    async getmptypeslist() {
      const data = await mptypeslist()
      this.programtype = data.data.types
    },
    find(id) {
      console.log('id', id)
      const indexs = this.programtype.findIndex(item => {
        // eslint-disable-next-line eqeqeq
        return item.mini_program_type == id
      })
      if (indexs === -1) {
        return ''
      } else {
        return this.programtype[indexs].type_name
      }
    },

    staffcallback(item) {
      this.dialogVisible = false
      this.external_user_id = null
      this.external_name = ''
      this.employee_no = item.employee_no
      this.employee_name = item.name
      console.log('item', item)
    },
    choosecustom() {
      this.customdialogVisible = true
      this.$nextTick(() => {
        this.$refs.choosecustomview.customsend(this.employee_no)
      })
    },
    customcallback(item) {
      this.customdialogVisible = false
      this.external_user_id = item.external_user_id
      this.external_name = item.remark
      console.log('item', item)
    },
    updata() {
      this.employee_no = null
      this.employee_name = ''
      this.external_user_id = null
      this.external_name = ''
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.within_box{
  width: 190px;
  border: 1px solid #19be6b;
  height: 100%;
  padding: 8px 8px 8px 7px;
  margin-left: 23px;
  margin-top: 15px;
}
.title_boxr{
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 157px;
}
.imaetext{
  display: flex;
  justify-content: space-between;
}
.se_top{
  margin-top: 14px;
}
.describe_text{
  color: #999999;
  width: 136px;
  overflow: hidden;
  -webkit-line-clamp: 3;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  height: 50px;
}
.mincard{
  width: 215px;
  height: 251px;
  border: 1px solid #ccc;
  padding: 10px;
  box-sizing: border-box;
  margin: 10px 0px 0px 23px;
}
.mincard_title{
  font-size: 12px;
  margin-bottom: 5px;
  width: 100px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.imgrbox{
  width: 100%;
  height: 150px;
}
.line{
  width: 100%;
  height: 1px;
  background: #999999;
  /* margin: 5px 0px; */
  margin: 3px 0px;
}
.bottomwr{
  display: flex;
  align-items: center;
}
.mincard_enjoy{
  margin-bottom: 5px;
  width: 134px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.weadar{
  margin-left: 2px;
  font-size: 12px;
}
.all_box{
  margin: 8px 0px;
  max-height: 500px;
  overflow: hidden;
  overflow-y: auto;
  width: 100%;
}
.onebox{
  display: flex;
  align-items: center;
}
.swr{
  width: 50px;
  text-align: right;
}
.prview_box{
  /* max-height: 500px;
  overflow: hidden;
  overflow-y: scroll; */
  display: flex;
}
.prview_box::-webkit-scrollbar {
  width: 0;
}
.box_serw{
  color: rgb(169, 162, 151);
  font-size: 14px;
}
.phoner_box{
    background: url('https://mp.2f.com/v2.7.2/img/iphone6.395625b9.jpg') no-repeat;
    background-size: 100% 100%;
    width: 300px;
    height: 600px;
    margin:0 auto;
    position: relative;
}
.phoner_boxone{
    background: url('https://mp.2f.com/v2.7.2/img/iphone6.395625b9.jpg') no-repeat;
    background-size: 100% 100%;
    width: 300px;
    height: 600px;
    position: relative;
}
.at_box{
  margin: 10px 0px;
}
.all_boxr{
  max-height: 365px;
  overflow-y: auto;
  position: absolute;
  top: 120px;
  padding-left: 20px;
  box-sizing: border-box;
  width: 92%;
}
::-webkit-scrollbar {
  width: 10px;
  height: 1px;
}
::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background-color: #ccc;
}
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
  background: #ededed;
  border-radius: 5px;
}
.content_box{
  padding: 20px;
}
.form_box{
  margin-left: 60px;
}
.send_message{
  text-align: center;
  width: 360px;
  font-size: 18px;
  margin-bottom: 30px;
}
.tybox{
  display: flex;
}
</style>
